import React, { useRef, useState } from "react";

export const DraggableHelper = ({ id, children, onDrop, className, card, isOrderActive = false }) => {
  const [isDragging, setIsDragging] = useState(false);
  const refs = useRef()

  const handleDragStart = async  (e) => {
    const dragData = JSON.stringify({ id, card });
    e.dataTransfer.setData("application/json", dragData);
    setIsDragging(true);

    const dragImageElement = refs.current.cloneNode(true);
    dragImageElement.style.position = "absolute";
    dragImageElement.style.top = "-11110px";
    dragImageElement.style.left = "-11110px";
    dragImageElement.id = `drag-image-${id}`;
    document.body.appendChild(dragImageElement);
    e.dataTransfer.setDragImage(dragImageElement, 200, 200);
  
  };

  const handleDragEnd = () => {
    setIsDragging(false); // Reset dragging state when drag ends
    const dragImageElement = document.getElementById(`drag-image-${id}`);
    if (dragImageElement) {
      document.body.removeChild(dragImageElement);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const draggedData = JSON.parse(e.dataTransfer.getData("application/json"));
    e.stopPropagation();
    onDrop(draggedData.id, id, draggedData.card, card);
    setIsDragging(false); // Reset dragging state when an item is dropped
  };

  return (
    <div
    ref={refs}
      id={card}
      className={` ${className ? className : ''} ${!isOrderActive ? '' : 'tw-cursor-grabbing'} ${isDragging ? 'tw-cursor-grabbing' : ''}`} 
      style={isOrderActive ? { order: parseInt(id) } : {}}
      draggable={isOrderActive} 
      onDragStart={isOrderActive ? handleDragStart : undefined} 
      onDragOver={isOrderActive ? handleDragOver : undefined} 
      onDrop={isOrderActive ? handleDrop : undefined} 
      onDragEnd={isOrderActive ? handleDragEnd : undefined} 
    >
      {children}
    </div>
  );
};